import React from 'react';
import StatsWidgetStatsRow from './statsWidgetStatsRow.jsx';
import {store} from '../football_stats.jsx';

function showFullStatsReact(e) {
    store.dispatch({type: "SHOW_ALL_STATS", val: e});
}

/**
 * Compares 2 stats and sorts players by them
 * @param $a
 * @param $b
 * @return int
 */
function compareByStat(a, b)
{
    if(a[currentField] > b[currentField]) {
        return currentSort == 'asc' ? 1 : -1;
    } else {
        return currentSort == 'asc' ? -1 : 1;
    }
}

function closeDialog(e) {
    store.dispatch({type: "CLOSE_MODAL", val: e});
    $(this).closest('.ui-dialog-content').dialog('close');
}

let currentSeason;
let currentSort;
let currentField;
let numOfItems;
let selectedRound;
let currentLeague;
let currentStage;

const StatsWidget = ({
    category,
    players,
    teams,
    stats,
    stage,
    sort='desc',
    filter={},
    round=0,
    season='26/27',
    league='902',
    limit=5,
    loading,
    additionalClass=false,
    showAll=0,
    divider=0,
    type="player",
    inModal=false,
    catIndex=0
}) => {
    currentLeague = league;
    currentSeason = season;
    currentSort = sort;
    currentField = category.field;
    currentStage = stage;
    selectedRound = round;
    numOfItems = 0;
    let showAllhtml = '';
    if(showAll ) {
        showAllhtml = <button onClick={ showFullStatsReact} data-catindex={catIndex} type="button" data-cat={JSON.stringify(category)} className={ "stats-category-full-list-btn full-list-" + category.field } >
            <label className="stats-category-full-list-label"> { getByLang('Full List', 'רשימה מלאה', 'القائمة الكاملة') } </label>
            <div className="left-arrow"></div>
        </button>
    }

    let dividerHtml = '';
    if( divider ) {
        dividerHtml = <div className="stats-divider"></div>
    }

    let limitReached = false;

    // Count stats per player to detect players with multiple entries (team transfers)
    const playerStatCounts = {};
    if (type === 'player' && typeof stats !== 'undefined' && stats != null) {
        Object.values(stats).forEach(stat => {
            if (stat.playerId > 0) {
                playerStatCounts[stat.playerId] = (playerStatCounts[stat.playerId] || 0) + 1;
            }
        });
    }

    const sanitize = (stat) => {
        let res = true;

        if(type === 'player') {
            // check if stat is valid and had player id
            if(typeof stat.playerId === 'undefined' || stat.playerId <= 0) {
                // player stat is undefined or it's a team
                res = false;
            }
            // check if player exists in players list
            if(typeof players != 'undefined') {
                var player = players[stat.playerId];
                if(typeof player === 'undefined' ||
                    typeof player == null ||
                    typeof player !== 'object' ||
                    !player.hasOwnProperty('id') ||
                    !player.id ) {
                    res = false;
                    // console.log('Player Row failed:');
                    // console.log('player:' + player);
                    console.log('player id that failed:' + stat.playerId);
                }
            } else {
                console.log('No players array!!!');
            }
        } else { //team
            if(typeof stat.teamId === 'undefined' || stat.teamId <= 0) {
                // player stat is ether undefined or it's a team
                res = false;
            }

            if(stat.playerId != -1) {
                res = false; //Remove player stats from team stats
            }

            if(typeof teams != 'undefined') {
              var team = teams[stat.teamId];
                if(typeof team === 'undefined' || team == null || typeof
                    team !== 'object' || !team.hasOwnProperty('id') || !team.id){
                    res = false;
                }
            }
        }

        return res;
    }
    return (
        <div className={"stats-widget-container"}>
            {( !(typeof stats != 'undefined' && stats != null) || loading) ?
                <div className={"col-xs-12"}>
                    <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>:
            <div id={"playerList" + currentField } className={ (additionalClass ? additionalClass: "" ) + "stats-category-item col-xs-12"}>
            <i className={"close-dialog fa fa-times pull-right" + inModal ? "" : "hidden" } aria-hidden="true" onClick={closeDialog}></i>
            <label title={getObjField(category, 'tooltip')} className="stats-category-item-title">{getObjField(category)}</label>
            <ul className={ (category.isOpen ? "stats-open" : "") + " player-list" } >
                {
                    Object.values(stats)
                        .filter( (stat, index) => (((type == 'player' && stat['playerId'] > 0) || (type == 'team' && stat['teamId'] > 0)) && stat[currentField] >= 0))
                        .filter(stat => {
                            if (type !== 'player' || playerStatCounts[stat.playerId] <= 1) return true;
                            var player = players[stat.playerId];
                            return player && stat.teamId == player.teamId;
                        })
                        .sort(compareByStat)
                        .filter((stat, index) => {
                            if(numOfItems < limit) { //Check limit of items
                                for (let property in filter) { //Check dynamic object filter

                                    if(property == "stage") {
                                        continue;
                                    }

                                    if (filter.hasOwnProperty(property)) {
                                        if( (type == 'player' && property == 'teamId') ||
                                            (type == 'team' && property =='id')) {
                                            //Check player team ID compares to the stats and that there is value
                                            if(type == 'player' && (typeof stat['playerId'] == 'undefined' || typeof players[stat['playerId']] == 'undefined' || players[stat['playerId']] == null || players[stat['playerId']][property] != filter[property])) {
                                                return false;
                                            } else if(type == 'team' && (typeof stat['teamId'] == 'undefined' || typeof teams[stat['teamId']] == 'undefined' || teams[stat['teamId']] == null || teams[stat['teamId']]['id'] != filter[property])){
                                                return false;
                                            }
                                        } else if(typeof filter[property] == 'object' && filter[property] != null) {
                                            let objectKeys = Object.keys(filter[property]);
                                            for (let i in objectKeys) {
                                                let objectKey = objectKeys[i];
                                                if(stat[property][objectKey] != filter[property][objectKey]) {
                                                    return false;
                                                }
                                            }
                                        } else if(filter[property] != null && (type =='player' && (typeof players[stat['playerId']] == 'undefined' ||
                                            typeof players[stat['playerId']][property] !== 'object' && players[stat['playerId']][property] != filter[property]))) {
                                                return false;
                                        }
                                    }
                                }

                                limitReached = false;
                                numOfItems++;
                                return true;
                            } else {
                                limitReached = true;
                            }

                            return false;
                        })
                        .map( (stat, index) => {
                            if(sanitize(stat)) {
                                return (
                                    <StatsWidgetStatsRow
                                        type={type}
                                        player={players[stat.playerId]}
                                        team={typeof teams !=='undefined' && typeof teams[stat.teamId] !=='undefined' && stat.teamId != null ? teams[stat.teamId] : null}
                                        season={currentSeason}
                                        league={currentLeague}
                                        stats={stat}
                                        stage={currentStage}
                                        category={category}
                                    />
                                )
                            }
                        }
                    )
                }
            </ul>
            { limitReached ? showAllhtml : '' }
            { dividerHtml }
            </div>}
        </div>
    )
};

export default StatsWidget;
